<div class="info-popover flex flex-col items-center justify-center gap-2.5">
  <span class="title">Orientación del folio</span>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/pageOrientation/vertical.png" />
    <div class="flex flex-col gap-1.5">
      <span class="section_title">Vertical</span>
      <span class="section_info">Se impreme tu documento en folios en vertical.</span>
    </div>
  </div>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/pageOrientation/horizontal.png" />
    <div class="flex flex-col gap-1.5">
      <span class="section_title">Horizontal</span>
      <span class="section_info">Se imprime tu documento en folios en horizontal.</span>
    </div>
  </div>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/pageOrientation/infoOrientation.png" />
    <div class="flex flex-col gap-1.5">
      <span class="section_title">¿Y si tengo cosas en horizontal y en vertical mezcladas dentro del pdf?</span>
      <span class="section_info"
        >Si tu documento está en vertical y tienes tablas u otros tipos de recursos en horizontal dentro del propio
        documento, respetaremos su orientación. No aplica al grapado, éste se ajustará a la orientación
        seleccionada.</span
      >
    </div>
  </div>
</div>
